import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a6fad73b4287195250628b0675dbf1c45b from "./generated-d7c15c7c-ec71-4544-95cf-2b128619d78a.json";

import a999421a05f5378410fc025f2e87c3be0b from "./generated-d6e8fae8-de4a-4608-b426-7fc1abbb8a74.json";

import af5a97f7728989a473a86bb8279a9b965b from "./generated-10e3fe72-1949-4c87-9213-530207c194ed.json";

import a07e277722d7e30adc889f1841805d158b from "./generated-024a5496-4654-409d-9ae5-e15956c2d092.json";

import a2d28e51358df45f2819d86cc8589506db from "./generated-a0258bc1-ccf5-44ad-ba20-1f87e7182ab1.json";

import a772dd1c87534d95d98e2d0f3076f07f5b from "./generated-a9a2e355-7c7c-4087-9149-3072d36ab3d9.json";

import a922e9691dc4d4912574511c164549d38b from "./generated-6c0d208d-92ea-4e97-aa45-64dc7c941537.json";

import a9d931f1448fb090c04b71fdf46418d92b from "./generated-e8a5c789-afda-4bf1-a0e2-0a546b5234f6.json";

import ad7c00726226d6ac5724fe7d83412e894b from "./generated-8e685b64-4128-4f92-9639-00e4ed56249a.json";

import af76376b45290bb270cbc359b2930ff5ab from "./generated-f230ad7c-66dd-4ebc-8656-359f1fd6a07b.json";

import a71d76ba71387fe3cb55644e7e9eb614cb from "./generated-809ab6a3-b91a-441e-9f72-b3e38e056040.json";

import a1324b1b2d2d6fc42afb562ded27a5429b from "./generated-90bb294a-b0c3-4514-8381-0394f3aef074.json";

import a5840b1e767bfdfc57f90066a27c68172b from "./generated-a5fd2f0e-86fd-4929-af64-eacd1d61efaa.json";

import ad95507ae101a6f3228b5c079fb8fd6f9b from "./generated-7813dbe9-fd16-493b-8506-a61dc5a68a22.json";

import a0328b0f40b663b354da2ddbb6e21651eb from "./generated-928f6666-90e8-4e5b-b55f-fb4eebc20efe.json";

import a0649f356851f4f5f03465a3893306253b from "./generated-6f38e2aa-aed4-458e-92a4-d04be2391633.json";

import a3d9434772154ed85aba9f26922fd87deb from "./generated-25b8fa07-b36a-4091-9821-11ac378a3f86.json";

import a9eab886b1a29374be1cdd30d3835fad5b from "./generated-a3b3f145-8867-4ba4-a0d2-902a8425383d.json";

import a27d15b37f1a77916eb11f7c43ff4cb7fb from "./generated-6a7190be-f15d-4b05-9a00-0999d28fb10e.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a6fad73b4287195250628b0675dbf1c45b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a999421a05f5378410fc025f2e87c3be0b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(af5a97f7728989a473a86bb8279a9b965b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a07e277722d7e30adc889f1841805d158b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a2d28e51358df45f2819d86cc8589506db);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a772dd1c87534d95d98e2d0f3076f07f5b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a922e9691dc4d4912574511c164549d38b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a9d931f1448fb090c04b71fdf46418d92b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(ad7c00726226d6ac5724fe7d83412e894b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(af76376b45290bb270cbc359b2930ff5ab);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a71d76ba71387fe3cb55644e7e9eb614cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a1324b1b2d2d6fc42afb562ded27a5429b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a5840b1e767bfdfc57f90066a27c68172b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(ad95507ae101a6f3228b5c079fb8fd6f9b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a0328b0f40b663b354da2ddbb6e21651eb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a0649f356851f4f5f03465a3893306253b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a3d9434772154ed85aba9f26922fd87deb);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a9eab886b1a29374be1cdd30d3835fad5b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a27d15b37f1a77916eb11f7c43ff4cb7fb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a3d9434772154ed85aba9f26922fd87deb);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */